module.exports = __webpack_public_path__ + "media/zhibo.3ec11f65.mp3";